export enum FIELD_TYPE {
  DISABLED_TEXT = "DISABLED_TEXT",
  SINGLE_INPUT = "SINGLE_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  SUGGESTION_INPUT = "SUGGESTION_INPUT",
  RADIO_GROUP = "RADIO_GROUP",
  DATERANGE_PICKER = "DATERANGE_PICKER",
  DATEPICKER = "DATEPICKER",
  MULTIPLE_SELECT = "MULTIPLE_SELECT",
  MULTIPLE_SUGGESTION_INPUT = "MULTIPLE_SUGGESTION_INPUT",
  EMPTY = "EMPTY",
  NUMBER_INPUT = "NUMBER_INPUT"
}
